import React from "react";
import { FormSpyRenderProps, FormSpy } from "react-final-form";
import { diff } from "deep-object-diff";
type Props = {
	onAutoSave: (values: object, difference: object) => Promise<void>;
};

class AutoSave extends React.Component<FormSpyRenderProps & Props> {
	promise: Promise<any>;

	componentDidMount() {
		//this.props.onAutoSave(this.props.values, {});
	}

	async componentDidUpdate(prevProps) {
		const { values } = this.props;

		// This diff step is totally optional
		const difference = diff(prevProps.values, values);
		if (Object.keys(difference).length > 0) {
			// values have changed
			this.promise = this.props.onAutoSave(values, difference);
			await this.promise;
			delete this.promise;
		}
	}

	render() {
		return <></>;
	}
}

export default props => <FormSpy {...props} subscription={{ active: true, values: true }} component={AutoSave} />;
